import dayjs from 'dayjs'
import { postBatchRedtailQueries } from '../../../../../api/redtail'

const pastDueTasks = {
  key: 'past-due-tasks',
  displayName: 'Past Due Tasks',
  defaults: {
    icon: 'redtailSmall',
    title: 'Past Due',
    label: 'Incomplete Tasks',
    format: '0,0'
  },

  async fetchData (members, clientId) {
    const today = dayjs().format('YYYY-MM-DD')
    const startDate = dayjs().subtract(1, 'year').format('YYYY-MM-DD')

    const { results } = await postBatchRedtailQueries(
      members.map(member => ({
        query: 'listActivities',
        request: {
          params: {
            contact_id: member.contact_id ?? member.id,
            start_date: startDate,
            end_date: today
          }
        }
      })),
      { clientId }
    )

    return results
      .filter(r => r.status === 'fulfilled')
      .flatMap(r => r.data?.activities ?? [])
  },

  compute (activities) {
    return activities.filter(a =>
      a.activity_code_id === 1 && !a.completed
    ).length
  }
}

const presets = {
  'past-due-tasks': pastDueTasks
}

export default presets
